<template>
    <div class="main-top form-top-section relative z-40 p-4 md:px-0 sm:max-w-540px flex mx-auto flex-wrap">
        <!-- <div class="section-bg bg-primary-gradient -bottom-half z-10 relative"></div> -->
        <!-- <div class="form-top-section-content container text-center z-10 relative">
            <div class="mx-auto pt-2 w-full md:w-1/2 px-2">
                <h1 class="font-roundo-bold font-bold text-2xl md:text-3.5xl">Hi {{ customer.forename | capitalize }}</h1>
                <p
                    class="mt-4 md:mt-5 md:mb-0 text-lg md:text-1.5xl"
                >Let's get you a smaller loan!<br> We just need to know:</p>
            </div>
        </div> -->

        <div class="flex w-full form-top-section-content container text-center z-10 relative p-0">
            <div class="mx-auto w-full bg-stop-section p-8 rounded-lg shadow-lg">
                <span class="text-6xl text-white font-bold">STOP</span>
                <div class="text-white text-2xl font-bold">
                    {{ customer.forename | capitalize }}, we have more lenders matched to you!
                </div>
            </div>
        </div>

        <div class="flex w-full form-top-section-content container text-center z-10 relative px-4 pt-4">
            <div class="mx-auto pt-2 w-full px-4">
                <ul class="list-none p-0 font-normal m-0">
                    <li class="text-lg"><img src="/img/form/label-tick.svg" class="mr-4" height="28" width="28">No more forms to fill</li><br>
                    <li class="text-lg"><img src="/img/form/label-tick.svg" class="mr-4" height="28" width="28">No affect to your credit score</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['form', 'customer']
}
</script>

<style lang="scss">
.bg-stop-section {
    background: repeating-linear-gradient(68deg, rgba(255,105,97,1) 0px, rgba(255,105,97,1) 22px, rgba(249,95,87,1) 22px, rgba(249,95,87,1) 44px);
}
</style>